/* tslint:disable */
/* eslint-disable */
/**
 * Easy Templates Internal API
 * This is an internal REST API for Easy Templates application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VariableConfig } from './VariableConfig';
import {
    VariableConfigFromJSON,
    VariableConfigFromJSONTyped,
    VariableConfigToJSON,
} from './VariableConfig';
import type { VariableValue } from './VariableValue';
import {
    VariableValueFromJSON,
    VariableValueFromJSONTyped,
    VariableValueToJSON,
} from './VariableValue';

/**
 * 
 * @export
 * @interface VariableResponse
 */
export interface VariableResponse {
    /**
     * Label of the variable, used in markup
     * @type {string}
     * @memberof VariableResponse
     */
    label: string;
    /**
     * Description of the variable, used to explain its purpose
     * @type {string}
     * @memberof VariableResponse
     */
    description: string;
    /**
     * Whether the variable is required to have a value to create issues from its template
     * @type {boolean}
     * @memberof VariableResponse
     */
    required: boolean;
    /**
     * The type of the variable, specifies both the kind of data a variable can store and what widget is used for its display
     * @type {string}
     * @memberof VariableResponse
     */
    type: VariableResponseTypeEnum;
    /**
     * 
     * @type {VariableValue}
     * @memberof VariableResponse
     */
    defaultValue: VariableValue;
    /**
     * 
     * @type {VariableConfig}
     * @memberof VariableResponse
     */
    config: VariableConfig | null;
    /**
     * Identifier of the variable
     * @type {string}
     * @memberof VariableResponse
     */
    id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof VariableResponse
     */
    issueIds: Array<string>;
}


/**
 * @export
 */
export const VariableResponseTypeEnum = {
    Text: 'text',
    Longtext: 'longtext',
    Select: 'select',
    Multiselect: 'multiselect',
    Number: 'number',
    Date: 'date'
} as const;
export type VariableResponseTypeEnum = typeof VariableResponseTypeEnum[keyof typeof VariableResponseTypeEnum];


/**
 * Check if a given object implements the VariableResponse interface.
 */
export function instanceOfVariableResponse(value: object): value is VariableResponse {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('required' in value) || value['required'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('defaultValue' in value) || value['defaultValue'] === undefined) return false;
    if (!('config' in value) || value['config'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('issueIds' in value) || value['issueIds'] === undefined) return false;
    return true;
}

export function VariableResponseFromJSON(json: any): VariableResponse {
    return VariableResponseFromJSONTyped(json, false);
}

export function VariableResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VariableResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'description': json['description'],
        'required': json['required'],
        'type': json['type'],
        'defaultValue': VariableValueFromJSON(json['defaultValue']),
        'config': VariableConfigFromJSON(json['config']),
        'id': json['id'],
        'issueIds': json['issueIds'],
    };
}

export function VariableResponseToJSON(value?: VariableResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'label': value['label'],
        'description': value['description'],
        'required': value['required'],
        'type': value['type'],
        'defaultValue': VariableValueToJSON(value['defaultValue']),
        'config': VariableConfigToJSON(value['config']),
        'id': value['id'],
        'issueIds': value['issueIds'],
    };
}

